module.exports = __webpack_public_path__ + "static/media/thawte.43101e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/compra-segura/thawte.png
// module id = 247
// module chunks = 0